export const QUESTION_TYPES = {
  TEAM: 'team',
  PLAYER: 'player',
  PROP: 'prop',
  OVER_UNDER: 'over_under',
  // Main markets (DKPLAT-500). Moneyline/Spread render as option picks (2–3
  // tiles, incl. a logo-less Draw for draw-capable sports); Total is a
  // match-level Over/Under on the combined score. Total is rendered by the
  // OVER_UNDER component but has no player subject — the adapter flags it
  // `isMatchLevel` so the card shows the matchup, not a "U. Player" placeholder.
  MONEYLINE: 'moneyline',
  SPREAD: 'spread',
  TOTAL: 'total',
  TIEBREAKER: 'tiebreaker',
  CUSTOM: 'custom',
  // Outcome markets (DKPLAT-871) — rendered by the Custom card, graded from the feed.
  OUTCOME: 'outcome',
  // Cross-fixture leader questions (DKPLAT-354): the question spans every
  // fixture inside the pickem's contest window. Customers pick a single
  // player/team from a curated list; the option with the highest cumulative
  // stat across those fixtures wins. No single fixtureExternalId on the
  // question — the fixture set lives in questionMetadata.leaderboard.
  PLAYER_LEADER: 'player_leader',
  TEAM_LEADER: 'team_leader',
} as const;

export type QuestionType = (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];

/**
 * Question types whose answer is a chosen option, stored in the `teams`
 * selection bucket on the frontend (keyed by question_id → option_id),
 * regardless of the underlying team/player/custom/leader/main-market
 * semantics. Used by selection quick-pick, fav-pick, and rehydration so a
 * new option-based type only has to be added here once.
 */
export const OPTION_SELECTION_QUESTION_TYPES: readonly string[] = [
  QUESTION_TYPES.TEAM,
  QUESTION_TYPES.PLAYER,
  QUESTION_TYPES.CUSTOM,
  QUESTION_TYPES.PLAYER_LEADER,
  QUESTION_TYPES.TEAM_LEADER,
  QUESTION_TYPES.MONEYLINE,
  QUESTION_TYPES.SPREAD,
  QUESTION_TYPES.OUTCOME,
];

/**
 * Question types rendered as an Over/Under pick, stored in the `overUnder`
 * selection bucket ('over' | 'under').
 */
export const OVER_UNDER_QUESTION_TYPES: readonly string[] = [
  QUESTION_TYPES.OVER_UNDER,
  QUESTION_TYPES.TOTAL,
];
